import React from "react"
import { Container } from "react-bootstrap"
import MenuMain from "../../Components/Home/MenuOnly"
const MenuMainPage = () => {
  return (
    <Container fluid className="p-0" style={{ height: "100dvh" }}>
      <MenuMain />
    </Container>
  )
}
export default MenuMainPage
